import { createContext, useContext } from "react";
import { TrackingContextState } from "./types";

export const initialState: TrackingContextState = {
  trackEvent: () => {},
  trackPurchase: () => {},
};

export const TrackingContext =
  createContext<TrackingContextState>(initialState);

export const useTracking = () => useContext(TrackingContext);
